import React, { useEffect, memo, useState } from "react";
import {
    Switch,
    useColorModeValue,
    Button,
    TagLabel,
    Box,
    Center,
    Text,
} from "@chakra-ui/react";
import { getAccount, getAuthUrl, updateUser } from "../../utils/sessionHelper";
import { useSession } from "next-auth/client";
import * as analytics from "../../utils/analytics";

export const ActivateAnalytics = ({callback=undefined as Function | undefined}) => {
    const [session, loading] = useSession();
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Box display="flex" justifyContent="center">
            <Center maxW="400px" mt={20} display="flex" flexDirection="column">
            <Text>Press the button bellow to start fetching your tweets data. This can take up to a few minutes.</Text>
            <Button isLoading={isLoading} mt={5} maxW="300px" variant={"primary"}
                onClick={async () => {
                    setIsLoading(true);

                    if (callback)
                        await callback();
                }}
            >
                Start Using Tweets Analytics
            </Button>
            </Center>
        </Box>
    )
}

